import { useCallback, useMemo, useState } from "react";

export const useLocalStorage = <T extends string>(
  itemName: string,
  defaultValue: T,
) => {
  const [value, setValue] = useState<T>(
    () => (window.localStorage.getItem(itemName) as T) ?? defaultValue,
  );
  const updateValue = useCallback(
    (newValue: T) => {
      setValue(newValue);
      window.localStorage.setItem(itemName, newValue);
    },
    [itemName],
  );

  return useMemo(() => [value, updateValue] as const, [value, updateValue]);
};
